import { render, staticRenderFns } from "./newsTemplate.vue?vue&type=template&id=13bd5906&scoped=true&"
import script from "./newsTemplate.vue?vue&type=script&lang=js&"
export * from "./newsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bd5906",
  null
  
)

export default component.exports